import { InMemoryCache } from "@apollo/client";
import { relayStylePagination } from "@apollo/client/utilities";

export const createCache = () => {
  const cache = new InMemoryCache({
    typePolicies: {
      Query: {
        fields: {
          pharmaciesSearch: relayStylePagination([
            "keyword",
            "latitude",
            "longitude",
            "onlyGuidance",
          ]),
          visits: relayStylePagination([
            "failedOnly",
            "onOrBeforeYesterdayOnly",
            "todayOnly",
            "unfailedOnly",
          ]),
          histories: relayStylePagination(["failedSettlementOnly", "unfailedSettlementOnly"]),
        },
      },
    },
  });

  return cache;
};
